function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M468 74c-1-2-7-25-30-35A4723 4723 0 00335 0H177l-3 1L74 39a54 54 0 00-30 35l-20 84 79 69v253h306V227l79-69-20-84z",
  fill: "#ff7140"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57 51a58 58 0 00-13 23l-20 84 79 69V127L57 51z",
  fill: "#e03c2f"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#d83a25",
  d: "M81 177v31l22 19V127L81 90z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M468 74c-1-1-4-13-13-23l-46 76v100l79-69-20-84z",
  fill: "#e03c2f"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M257 93c41 0 80-40 80-93H176c0 53 39 93 81 93z",
  fill: "#ed4d2e"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292 0c0 43-26 77-58 88 7 3 15 5 23 5 41 0 80-40 80-93h-45z",
  fill: "#d83a25"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278 37h-43a8 8 0 110-17h43a8 8 0 110 17z",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fcf1d4"
}, React.createElement("path", {
  d: "M249 29c0-5 3-9 8-9h-22a8 8 0 100 17h22c-5 0-8-4-8-8zM17 185c-1 4 2 9 6 10l80 32v-36l-79-33-7 27z"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f7dda4",
  d: "M81 187v31l22 9v-36l-22-9z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#d83a25",
  d: "M431 177v31l-22 19V127l22-37z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M495 185l-3-10-4-17-79 33v36l80-32c4-1 7-6 6-10z",
  fill: "#fcf1d4"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f7dda4",
  d: "M431 187v31l-22 9v-36l22-9z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168 478h-65v25c0 5 4 9 9 9h288c5 0 9-4 9-9v-25H168z",
  fill: "#fcf1d4"
});

var SvgShirt = function SvgShirt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShirt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shirt.2e0cc732.svg";
export { ForwardRef as ReactComponent };